import EmblaCarousel from "embla-carousel";

var emblaBlogCarousel;

// v2026/src/js/components/blog-listing-carousel.js
document.addEventListener("DOMContentLoaded", function () {
  var emblaNode = document.getElementById("blogEmbla");
  if (emblaNode) {
    var viewport = emblaNode.querySelector(".embla__viewport");
    emblaBlogCarousel = EmblaCarousel(viewport, {
      loop: false,
      slidesToScroll: 1,
      dragFree: false,
      //   containScroll: "trimSnaps",
      breakpoints: {
        "(max-width: 1024px)": { slidesToScroll: 1 },
      },
    });

    const dotsNode = emblaNode.querySelector(".embla__dots");

    if (dotsNode) {
      // Create dot buttons
      const dots = Array.from(
        { length: document.querySelectorAll(".embla__slide").length },
        (_, i) => {
          const dot = document.createElement("button");
          dot.className = "embla__dot";
          dot.innerHTML = `<span class="sr-only">Go to slide ${i + 1}</span>`;
          dotsNode.appendChild(dot);
          return dot;
        }
      );

      // Update dots on scroll
      const updateDots = () => {
        const selectedIndex = emblaBlogCarousel.selectedScrollSnap();
        dots.forEach((dot, index) => {
          dot.classList.toggle("is-selected", index === selectedIndex);
        });
      };

      // Initialize dots
      updateDots();
      emblaBlogCarousel.on("scroll", updateDots);

      // Add click handlers
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          emblaBlogCarousel.scrollTo(index);
        });
      });
    }

    // Navigation
    var prevBtn = emblaNode.querySelector(".embla__prev");
    var nextBtn = emblaNode.querySelector(".embla__next");
    prevBtn.addEventListener("click", emblaBlogCarousel.scrollPrev, false);
    nextBtn.addEventListener("click", emblaBlogCarousel.scrollNext, false);
  }
});
